<template>
  <div>
    <div v-if="dialogTableVisible" style="
        width: 100%;
        height: 100%;
        background: transparent;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: 888;
      " @click="onClickSelect"></div>
    <div style="
        z-index: 999;
        border: 1px solid #c0c4cc;
        border-radius: 1px;
        height: 32px;
        border-radius: 4px;
        width: 220px;
        font-size: 12px;
        color: #a2b1cb;
        display: flex;
        align-items: center;
        padding-left: 8px;
        cursor: pointer;
        position: relative;
      ">
      <div style="position: relative; display: flex; width: 100%" @click="onClickSelect">
        <selectedItem v-for="(item, index) in selectedItems" :key="item.index" :value="item.name"
          v-if="index == 0 || index == 1" />
        <el-tag v-if="selectedItems.length > 2" type="info" size="small">+ {{ selectedItems.length - 2 }}</el-tag>

        <span v-if="selectedItems.length == 0"> {{ value }}</span>

        <i style="
            position: absolute;
            right: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          " :class="!dialogTableVisible
              ? 'el-input__icon el-icon-arrow-down'
              : 'el-input__icon el-icon-arrow-up'
            "></i>
      </div>

      <div v-if="dialogTableVisible" style="
          position: absolute;
          left: 0;
          top: 30px;
          padding-top: 4px;
          z-index: 998;
          border
        ">
        <div
          style="border-radius: 4px;            padding: 8px;            width: 450px;            -webkit-box-sizing: border-box;            box-sizing: border-box;            background: #fff;            text-align: left;            -webkit-box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.06);            box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.06);          ">
          <div style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            ">
            <el-form :inline="true" size="mini" style="flex: 1">
              <el-form-item label="">
                <el-input v-model="searchKey" clearable placeholder="请输入车牌号"></el-input>
              </el-form-item>
            </el-form>
            <div v-if="multiple">
              选中车辆:{{ selectingItems.length }}/{{ gridData.length }}
            </div>
          </div>

          <el-table :data="gridData" size="small">
            <el-table-column width="55" align="center">
              <template slot-scope="scope">
                <el-checkbox v-if="multiple" v-model="scope.row.isChecked"
                  @change="handleChecked(scope.row)"></el-checkbox>
                <el-radio v-if="!multiple" :label="scope.row.id" v-model="selected"
                  @change="handleChecked(scope.row)"></el-radio>
              </template>
            </el-table-column>
            <el-table-column property="name" align="center" label="车辆">
              <template slot-scope="scope">
                <div style="
                    word-break: normal;
                    overflow: hidden;
                    white-space: nowrap;
                  " :title="scope.row.name">
                  {{ scope.row.name }}
                </div>
              </template>
            </el-table-column>

            <el-table-column property="oilTypeID_New" align="center" label="动力类型">
              <template slot-scope="scope">
                <span>{{ getOilType(scope.row.oilTypeID_New) }}</span>
              </template>
            </el-table-column>
            <el-table-column property="vehicleModel" align="center" label="车型">
              <template slot-scope="scope">
                <div style="
                    word-break: normal;
                    overflow: hidden;
                    white-space: nowrap;
                  " :title="scope.row.vehicleModel">
                  {{ scope.row.vehicleModel }}
                </div>
              </template>
            </el-table-column>
          </el-table>
          <kl-pagination :total="totalEventCount" :page-size="pageSize" @current-change="handleEventCurrentChange"
            :current-page.sync="current_event_page">
          </kl-pagination>
          <div style="
              padding: 10px 20px 0px 10px;
              text-align: right;
              box-sizing: border-box;
            ">
            <el-button @click="dialogTableVisible = false" size="small">取 消</el-button>
            <el-button @click="onResetClick" size="small">重 置</el-button>
            <el-button size="small" type="primary" @click="onOkClick">确 定</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import selectedItem from "./selectedItem.vue";

import { getVehicles } from "@/utils/auth";
export default {
  components: {
    selectedItem,
  },
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    // gridData: {
    //   type: Array,
    //   default: [],
    // },
  },
  computed: {
    vehicles() {
      var vlist = JSON.parse(getVehicles());

      // console.log(this.selectedVehicles);
      return vlist.filter((item) => item.treeLevel == 5);
    },
    gridData() {
      //分页

      var start = (this.current_event_page - 1) * this.pageSize;
      var end = start + this.pageSize;
      var temp = this.vehicles.filter((item) => {
        return item.name.indexOf(this.searchKey) != -1;
      });
      this.totalEventCount = temp.length;
      var data = temp.slice(start, end);

      return data;
    },
  },
  watch: {
    searchKey() {
      this.current_event_page = 1;
      // this.totalEventCount = this.vehicles.length;
      // var start = (this.current_event_page - 1) * this.pageSize;
      // var end = start + this.pageSize;
      // var temp = this.vehicles.filter((item) => {
      //   return item.name.indexOf(this.searchKey) != -1;
      // });
      // this.totalEventCount =temp.length;
      // var data = temp.slice(start, end);

      // return data;
    },
  },
  data() {
    return {
      searchKey: "",
      pageSize: 10,
      totalEventCount: 0,
      current_event_page: 1,
      selected: "",
      dialogTableVisible: false,
      // gridData: [
      //   {
      //     id: 1,
      //     carno: "闽D123456",
      //     group: "第一分公司",
      //     type: "纯电",
      //     vmodel: "XMQ6127",
      //     isChecked: false,
      //   },
      //   {
      //     id: 2,
      //     carno: "闽D234567",
      //     group: "第一分公司",
      //     type: "纯电",
      //     vmodel: "XMQ6127",
      //     isChecked: false,
      //   },
      //   {
      //     id: 3,
      //     carno: "闽D345678",
      //     group: "第一分公司",
      //     type: "纯电",
      //     vmodel: "XMQ6127",
      //     isChecked: false,
      //   },
      //   {
      //     id: 4,
      //     carno: "闽D456789",
      //     group: "第一分公司",
      //     type: "纯电",
      //     vmodel: "XMQ6127",
      //     isChecked: false,
      //   },
      // ],
      value: "请选择车辆...",
      selectingItems: [],
      selectedItems: [],
    };
  },
  mounted() {
    console.log("dssss");
    console.log(this.selectedVehicles);
  },
  methods: {
    getOilType(type) {
      // 1 柴油 2 气体机 3 油电 4 气电 5 纯电动  6 燃料电池
      switch (type) {
        case 1:
          return this.$t("oiltype.caiyouji");
        case 2:
          return this.$t("oiltype.qitiji");
        case 3:
          return this.$t("oiltype.youdain");
        case 4:
          return this.$t("oiltype.qidian");
        case 5:
          return this.$t("oiltype.chundiandong");
        case 6:
          return this.$t("oiltype.ranliao");
        default:
          return this.$t("oiltype.unKnown");
      }
    },
    handleEventCurrentChange(page) {
      this.current_event_page = page;
    },
    onOkClick() {
      this.selectedItems = this.selectingItems.slice();
      this.dialogTableVisible = false;
      this.$emit("ok", this.selectedItems); //数据提供
    },
    handleChecked(row) {
      if (this.multiple) {
        if (row.isChecked) this.selectingItems.push(row);
        else {
          this.selectingItems = this.selectingItems.filter(
            (item) => item.nodeValue != row.nodeValue
          );
        }
      } else {
        this.selectingItems = [row];
      }
    },
    onResetClick() {
      this.gridData.forEach((item) => {
        item.isChecked = false;
      });
      this.selectingItems = [];
      this.selected = "";
    },
    onClickSelect() {
      this.dialogTableVisible = !this.dialogTableVisible;
    },
  },
};
</script>
<style scoped>
/deep/ {
  .el-radio__label {
    display: none !important;
  }

  .el-table--small .el-table__cell {
    padding: 0px 0;
  }
}
</style>
